import { sendEvent } from './sendEvent';

export const goToRenewPrescription = (from: string = '') => {
  switch (from) {
    case 'MedicineHistory':
      sendEvent('Medicine', 'NewFileButtonMedicineHistory');
      break;
    case 'RenewPrescription':
      sendEvent('Medicine', 'ExpiredMedicineButtons');
      break;
    default:
      sendEvent('Medicine', 'NewMedicine');
      break;
  }

  window.open(
    process.env.REACT_APP_REDIRECT_URL + 'universalRequest/1/6/94',
    '_blank'
  );
};
